export const API_BASE_URL = 'https://santhai.kooturavu.tn.gov.in/api/v1';